import React, { Fragment, useEffect, useState } from 'react';

import { SRLWrapper } from "simple-react-lightbox";
import DatePicker from 'rsuite/DatePicker';

import { getIconoTable, getDatePickerDaysName }from '../../../helpers/helperApp';

import FixRequiredSelect from '../../../helpers/FixRequiredSelect';
import BaseSelect from "react-select";


function MiDataTableGesUplmRenovar(props){
    
    const { id, adjuntos, saveAdjuntos, readonly, estadoForm, traduction, optionSelect, datatable, saveAdjuntosParam, rowData, saveRowData } = props;

    let date = new Date();
    let mesHoy = date.getMonth() + 1;
    let h = date.getDate();
    let hoy = date.getFullYear()+'-'+(mesHoy < 10 ? mesHoy = '0'+mesHoy : mesHoy = mesHoy )+'-'+(h < 10 ? h = '0'+h : h = h );
    const [ fechaAlta, saveFechaAlta ] = useState(hoy);
    
    useEffect( () => {                                 
    },[adjuntos])
    
    const Select = props => (
        <FixRequiredSelect
            {...props}
            SelectComponent={BaseSelect}
            options={optionSelect || optionSelect}
        />
        );

    const customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor:'#ced4da',
            borderColor: state.isFocused ? '#80bdff': '#ced4da',
            outline: 0,
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgb(0 123 255 / 25%)' : 'inherit',
            background: readonly === "readonly" || estadoForm === "readonly" || state.isDisabled ? "#e9ecef" : "white",
            color: "#495057"
          }),
          option: (provided, state) => ({
            ...provided,
            color: "#212529"
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "#495057"
          }),
          menuPortal: (provided) => ({
            ...provided,            
            zIndex: 9999
          })  
    }
    
    const _URL = window.URL || window.webkitURL;

    const handleDeleteTmpAdjunto = async e => {
        e.preventDefault();

        await saveAdjuntos([]);

        const adjCancelar = e.target.dataset.id;
        const index = e.target.dataset.index;

        let noBorrar = adjuntos.filter(adjunto => adjunto.name != adjCancelar)

        //Actualizamos el state
        saveAdjuntos(noBorrar);
        if(saveAdjuntosParam) saveAdjuntosParam(noBorrar);

    }

    const handleChangeSelect = (selectedItem, nameOfComponent) => {

        const nameAdj = nameOfComponent.name.split("**")[1];
        const auxAdjExistentes = adjuntos.map((adjunto) => {

            if( adjunto.name == nameAdj ){
                if( selectedItem ){
                    adjunto.idtip = selectedItem.value;
                }else{
                    adjunto.idtip = "";
                }
            }
            return adjunto;
        });
        saveAdjuntos(auxAdjExistentes);
        if(saveAdjuntosParam) saveAdjuntosParam(auxAdjExistentes);
        
    }

    const handleChangeDescription = (e) => {
        const nameAdj = e.target.name.split("**")[1];
        const value = e.target.value;

        const auxAdjExistentes = adjuntos.map((adjunto) => {

            if( adjunto.name == nameAdj ){
                adjunto.description = e.target.value;
            }
            return adjunto;
        });

        saveAdjuntos(auxAdjExistentes);
        if(saveAdjuntosParam) saveAdjuntosParam(auxAdjExistentes);
    }

    const handleChangeFCad = (val, event, name) =>{
        // const value = e.target.value;
        const nameAdj = name.split("**")[1];
        let value;
        if(val == null){
            value = '0000-00-00';
        }else{
            const anho = val.getFullYear()
            const mes = val.getMonth()+1 < 10 ? '0'+(val.getMonth()+1) : val.getMonth()+1;
            const dia = val.getDate() < 10 ? '0'+val.getDate() : val.getDate();
            const horas = val.getHours() < 10 ? '0' + val.getHours() : val.getHours(); 
            const minutos = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
            // value = `${anho}-${mes}-${dia}T${horas}:${minutos}`;
            value = `${anho}-${mes}-${dia}`;
        }
        saveRowData({ ...rowData, fcad: value });
    }

    const handleChangeFa = (val, event, name) =>{
        // const value = e.target.value;
        const nameAdj = name.split("**")[1];
        let value;
        if(val == null){
            value = '0000-00-00';
        }else{
            const anho = val.getFullYear()
            const mes = val.getMonth()+1 < 10 ? '0'+(val.getMonth()+1) : val.getMonth()+1;
            const dia = val.getDate() < 10 ? '0'+val.getDate() : val.getDate();
            const horas = val.getHours() < 10 ? '0' + val.getHours() : val.getHours(); 
            const minutos = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
            // value = `${anho}-${mes}-${dia}T${horas}:${minutos}`;
            value = `${anho}-${mes}-${dia}`;
        }
        saveFechaAlta(value)
        saveRowData({ ...rowData, fa: value });
        
    }

    return(
            <SRLWrapper>                
                {
                    adjuntos.length > 0
                    ?
                        <table id={"pending-"+id} className={"pending-"+id+" table table-sm table-bordered table-hover dataTable"} style={{width:"100%"}}>
                            <thead>
                                <tr>
                            {
                                datatable.columns.map((columna, index, columns) => {                                
                                    if( columna.data != "groupby" ){
                                        return(
                                            <th key={index} style={{width: columna.width}} >{columna.title}</th>
                                        )
                                    }
                                })
                            }
                                </tr>
                            </thead>
                            <tbody>
                            {             
                                adjuntos.map((adj, index) => {                                                                
                                    if(adj){
                                        if( adj.urlAdd === undefined ){                                            
                                            adj.id=id;
                                            let confIco;
                                            if( adj["type"].split("/")[0] === "image" ){
                                                adj.src = _URL.createObjectURL(adj);
                                                adj.url = adj.src.replace("blob:","");
                                            }else{
                                                let ext = adj["name"].split(".")[adj["name"].split(".").length-1];
                                                confIco = getIconoTable(ext);
                                            } 
                                            return( 
                                                <tr key={index} className={'row-'+index}>
                                                    {/* <td>
                                                        { adj.src ? 
                                                                <div>                                   
                                                                        <div className="containerImgTablePending">
                                                                            <img className="imgUplmTablePending" src={adj.src} alt={adj.name} />
                                                                        </div> 
                                                                </div>
                                                                :
                                                                <div className="text-center">
                                                                    <i className={`${confIco["icono"]}`} style={{color:confIco["color"]}}></i>
                                                                </div>                                               
                                                        }
                                                    </td> */}
                                                    <td>
                                                        <div>                                        
                                                            <textarea 
                                                                placeholder={traduction.uplm.textarea.title} 
                                                                className="form-control fileNew" 
                                                                rows="1" 
                                                                defaultValue={rowData.des}
                                                                onChange={ handleChangeDescription } 
                                                                name={"fileReNew**"+adj.name} 
                                                                style={{resize: "none"}} >                                                
                                                            </textarea>                                            
                                                        </div>
                                                    </td>
                                                    <td>
                                                    <div className="">                                                        
                                                            <Fragment>
                                                                <Select
                                                                    className="fileReNew"  
                                                                    options={optionSelect}
                                                                    name={"fileReNew**"+adj.name+"**idtip"}             
                                                                    id={adj.name}
                                                                    placeholder={ "" } 
                                                                    // value={optionSelect.filter(option => option.value == adj.idtip)}
                                                                    onChange={ handleChangeSelect }
                                                                    // defaultValue={optionSelect.length == 1 ? optionSelect[0] : optionSelect.filter(option => option.value == adj.idtip)}
                                                                    defaultValue={optionSelect.filter(option => option.value == rowData.idtip)}
                                                                    required={false}
                                                                    isDisabled={ true }
                                                                    isClearable={false}
                                                                    isSearchable={false}
                                                                    isMulti={false}
                                                                    noOptionsMessage={ ({ inputValue: string }) => traduction.select.noresult.title } 
                                                                    // menuIsOpen={false}
                                                                    menuIsOpen={undefined}
                                                                    isReadOnly={false}
                                                                    styles={customStyles} 
                                                                    menuPortalTarget={document.querySelector('body')}
                                                                    menuPlacement={"auto"}
                                                                    formatOptionLabel={
                                                                        function(data) {
                                                                            return (
                                                                                <span dangerouslySetInnerHTML={{ __html: data.label }} />
                                                                            );
                                                                        }                                                                        
                                                                    }
                                                                />                                               
                                                                <input
                                                                    type="hidden"
                                                                    name={"fileReNew**"+adj.name+"**idtip"}
                                                                    value={rowData.idtip}
                                                                />
                                                            </Fragment>
                                                        </div>        
                                                    </td>                                        
                                                    <td>
                                                        <div className="" style={{minWidth: '150px'}}>                                                          
                                                            <Fragment>
                                                                <DatePicker
                                                                    id={adj.name}
                                                                    name={"fileReNew**"+adj.name+"**fa"}
                                                                    placeholder={' '}
                                                                    format={"yyyy-MM-dd"}
                                                                    // defaultValue={ rowData.fa == '0000-00-00T00:00' || rowData.fa == '0000-00-00' ||  rowData.fa == '' ? null : new Date(rowData.fa) }
                                                                    defaultValue={ new Date(fechaAlta) }
                                                                    onOk={(value, event) => handleChangeFa(value, event, "fileReNew**"+adj.name+"**fa")}
                                                                    onChange={ (value, event) => handleChangeFa(value, event, "fileReNew**"+adj.name+"**fa") }
                                                                    readOnly={ false }
                                                                    className={''}
                                                                    disabled={ false } 
                                                                    // showTime
                                                                    block={true}
                                                                    weekStart={1}
                                                                    locale={getDatePickerDaysName()}
                                                                    placement={'auto'}
                                                                />                                                                
                                                                <input type="hidden" 
                                                                    name={"fileReNew**"+adj.name+"**fa"} 
                                                                    value={fechaAlta} 
                                                                />
                                                            </Fragment>                                                            
                                                        </div>      
                                                    </td>
                                                    <td>
                                                    <div className="" style={{minWidth: '150px'}}>       
                                                        <Fragment>
                                                            <DatePicker
                                                                id={adj.name}
                                                                name={"fileReNew**"+adj.name+"**fcad"}
                                                                placeholder={' '}
                                                                format={"yyyy-MM-dd"}
                                                                defaultValue={ rowData.fcad == '0000-00-00T00:00' || rowData.fcad == '0000-00-00' ||  rowData.fcad == '' ? null : new Date(rowData.fcad) }
                                                                onOk={(value, event) => handleChangeFCad(value, event, "fileReNew**"+adj.name+"**fcad")}
                                                                onChange={ (value, event) => handleChangeFCad(value, event, "fileReNew**"+adj.name+"**fcad") }
                                                                readOnly={ false }
                                                                className={''}
                                                                disabled={ false } 
                                                                // showTime
                                                                block={true}
                                                                weekStart={1}
                                                                locale={getDatePickerDaysName()}
                                                                placement={'auto'}
                                                            />                                                                
                                                            <input type="hidden" name={"fileReNew**"+adj.name+"**fcad"} value={rowData.fcad} />
                                                        </Fragment>                                                            
                                                    </div>      
                                                    </td>
                                                    <td className="text-center">
                                                        <span 
                                                            id={ adj.name } 
                                                            className="btn btn-flat btn-outline-warning deleteRow" 
                                                            style={{border: 0}}
                                                            data-id={ adj.name } 
                                                            data-index={ index }
                                                            onClick={ e => { handleDeleteTmpAdjunto(e) } }
                                                        >
                                                            <i  
                                                                    className="fal fa-ban deleteRow"
                                                                    id={ adj.name } 
                                                                    data-id={ adj.name }
                                                                    data-index={ index }
                                                                    // onClick={ e => { handleDeleteTmpAdjunto(e) }}
                                                                >
                                                            </i>
                                                        </span>
                                                    </td>
                                                </tr>                                                                                
                                            ) 
                                        }else{                                            
                                            return(
                                                <tr key={index}>
                                                        {/* <td>
                                                            <div className="text-center">
                                                                <a href={ adj.urlAdd.toLowerCase().includes("https") || adj.urlAdd.toLowerCase().includes("http") || adj.urlAdd.toLowerCase().includes("file:///")?  adj.urlAdd : "https://"+adj.urlAdd} target="_blank" >
                                                                    <i className="fab fa-chrome fa-2x"></i>
                                                                </a>
                                                            </div>                                               
                                                        </td> */}
                                                        <td>
                                                            <div>                                                                                                        
                                                                <textarea 
                                                                    placeholder={traduction.uplm.textarea.title} 
                                                                    className="form-control fileNew" 
                                                                    rows="1" 
                                                                    defaultValue={rowData.des}
                                                                    onChange={ handleChangeDescription } 
                                                                    name={"fileReNewUrl**"+adj.urlAdd} 
                                                                    style={{resize: "none"}} >                                                
                                                                </textarea>
                                                                <input  type={ "hidden" } 
                                                                    className={ "form-control"} 
                                                                    id={ adj.name } 
                                                                    name={"fileReNewUrl**"+adj.name+"**name"} 
                                                                    placeholder={ "" }
                                                                    readOnly={ false }
                                                                    value={adj.name}
                                                                />                                                  
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="">                                        
                                                                <Select 
                                                                    className={ "fileNew"}
                                                                    options={optionSelect}
                                                                    name={"fileReNewUrl**"+adj.urlAdd+"**idtip"}             
                                                                    id={adj.name}
                                                                    placeholder={ "" } 
                                                                    // value={optionSelect.filter(option => option.value == adj.idtip)}
                                                                    onChange={ handleChangeSelect }
                                                                    // defaultValue={optionSelect.length == 1 ? optionSelect[0] : optionSelect.filter(option => option.value == adj.idtip)}
                                                                    defaultValue={optionSelect.filter(option => option.value == rowData.idtip)}
                                                                    required={false}
                                                                    isDisabled={ true }
                                                                    isClearable={false}
                                                                    isSearchable={false}
                                                                    isMulti={false}
                                                                    noOptionsMessage={ ({ inputValue: string }) => traduction.select.noresult.title } 
                                                                    // menuIsOpen={false}
                                                                    menuIsOpen={undefined}
                                                                    isReadOnly={false}
                                                                    styles={customStyles} 
                                                                    menuPortalTarget={document.querySelector('body')}
                                                                    menuPlacement={"auto"}
                                                                    formatOptionLabel={
                                                                        function(data) {
                                                                            return (
                                                                                <span dangerouslySetInnerHTML={{ __html: data.label }} />
                                                                            );
                                                                        }                                                                        
                                                                    }
                                                                />
                                                                <input
                                                                    type="hidden"
                                                                    name={"fileReNewUrl**"+adj.name+"**idtip"}
                                                                    value={rowData.idtip}
                                                                /> 
                                                            </div>                                                      
                                                        </td>
                                                        <td style={{minWidth: '150px'}}>                                                       
                                                            <Fragment>
                                                                <DatePicker
                                                                    id={adj.name}
                                                                    name={"fileReNewUrl**"+adj.name+"**fa"}
                                                                    placeholder={' '}
                                                                    format={"yyyy-MM-dd"}
                                                                    // defaultValue={ rowData.fa == '0000-00-00T00:00' || rowData.fa == '0000-00-00' ||  rowData.fa == '' ? null : new Date(rowData.fa) }
                                                                    defaultValue={ new Date(fechaAlta) }
                                                                    onOk={(value, event) => handleChangeFa(value, event, "fileReNew**"+adj.name+"**fa")}
                                                                    onChange={ (value, event) => handleChangeFa(value, event, "fileReNew**"+adj.name+"**fa") }
                                                                    readOnly={ false }
                                                                    className={''}
                                                                    disabled={ false } 
                                                                    // showTime
                                                                    block={true}
                                                                    weekStart={1}
                                                                    locale={getDatePickerDaysName()}
                                                                    placement={'auto'}
                                                                />                                                                 
                                                                <input type="hidden" name={"fileReNewUrl**"+adj.name+"**fa"} value={fechaAlta} />
                                                            </Fragment>
                                                        </td>
                                                        <td style={{minWidth: '150px'}}>                                                       
                                                            <Fragment>
                                                                <DatePicker
                                                                    id={adj.name}
                                                                    name={"fileReNewUrl**"+adj.name+"**fcad"}
                                                                    placeholder={' '}
                                                                    format={"yyyy-MM-dd"}
                                                                    defaultValue={ rowData.fcad == '0000-00-00T00:00' || rowData.fcad == '0000-00-00' ||  rowData.fcad == '' ? null : new Date(rowData.fcad) }
                                                                    onOk={(value, event) => handleChangeFCad(value, event, "fileReNew**"+adj.name+"**fcad")}
                                                                    onChange={ (value, event) => handleChangeFCad(value, event, "fileReNew**"+adj.name+"**fcad") }
                                                                    readOnly={ false }
                                                                    className={''}
                                                                    disabled={ false } 
                                                                    // showTime
                                                                    block={true}
                                                                    weekStart={1}
                                                                    locale={getDatePickerDaysName()}
                                                                    placement={'auto'}
                                                                />                                                                 
                                                                <input type="hidden" name={"fileReNewUrl**"+adj.name+"**fcad"} value={rowData.fcad} />
                                                            </Fragment>
                                                        </td>
                                                        <td className="text-center">
                                                            <span 
                                                                id={ adj.name } 
                                                                className="btn btn-flat btn-outline-warning deleteRow" 
                                                                style={{border: 0}}
                                                                data-id={ adj.name } 
                                                                data-index={ index }
                                                                onClick={ e => { handleDeleteTmpAdjunto(e) } }
                                                            >
                                                                <i  
                                                                        className="fal fa-ban deleteRow"
                                                                        id={ adj.name } 
                                                                        data-id={ adj.name }
                                                                        data-index={ index }
                                                                        // onClick={ e => { handleDeleteTmpAdjunto(e) }}
                                                                    >
                                                                </i>
                                                            </span>
                                                        </td>
                                                </tr>
    
                                            )
                                        }
                                    }
                                })
                            }
                            </tbody>
                        </table>  
                    :
                        null                    
                } 
            </SRLWrapper>                               
    )
}

export default MiDataTableGesUplmRenovar;